import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { JackingActivityEditor } from '../../../../models/projects/jacking-activity.models';
import { DateService } from '../../../../services/date/date.service';
import { DailyLogOperationInstance } from '../../../../models/projects/operation.models';
import { PtLuxonDate } from '../../../../models/projects/date.models';
import { TimeZoneService } from '../../../../services/time-zone/time-zone.service';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-jacking-activity-edit-cancel',
  templateUrl: 'jacking-activity-edit-cancel.html'
})
export class JackingActivityEditCancelPage {
  config = AppConfig.settings;

  mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  isWeb: boolean;
  loading: boolean;
  activitySpansMultipledays: boolean;
  editor: JackingActivityEditor;
  callback: Function;
  notes: string;
  cancellationTimeToShow: string;
  timeIsValid: boolean;

  primaryOperation: DailyLogOperationInstance;
  secondaryOperation: DailyLogOperationInstance;

  firstEventTime: PtLuxonDate;
  firstEventTimeShow: string;
  latestEventTime: PtLuxonDate;
  latestEventTimeShow: string;
  firstEventOffset: string;
  latestEventOffset: string;

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    public navParams: NavParams,
    private dateService: DateService,
    private timeZoneService: TimeZoneService,
  ) {
  }

  ngOnInit() {
    this.isWeb = this.platform.is('core');
    this.loading = true;
    this.ionViewEnter();
  }

  async ionViewEnter() {
    this.editor = this.navParams.get('activity');
    this.callback = this.navParams.get('callback');
    this.primaryOperation = this.navParams.get('primaryOperation');
    this.secondaryOperation = this.navParams.get('secondaryOperation');

    if (this.secondaryOperation && this.secondaryOperation.id == this.primaryOperation.id) {
      this.secondaryOperation = null;
    }

    const sortedEvents = this.editor.events
      .filter(e => e.time != null && e.time.dateTime != null)
      .sort(function (a, b) {
        return a.time.dateTime.toMillis() - b.time.dateTime.toMillis();
      });

    if (sortedEvents && sortedEvents.length > 0) {
      this.firstEventTime = sortedEvents[0].time;
      this.latestEventTime = sortedEvents[sortedEvents.length - 1].time;
      this.firstEventOffset = sortedEvents[0].timeOffset >= 0
        ? `(+${sortedEvents[0].timeOffset})`
        : `(-${sortedEvents[0].timeOffset})`;
      this.latestEventOffset = sortedEvents[sortedEvents.length - 1].timeOffset >= 0
        ? `(+${sortedEvents[sortedEvents.length - 1].timeOffset})`
        : `(-${sortedEvents[sortedEvents.length - 1].timeOffset})`;
    } else {
      this.firstEventTime = this.editor.startDate;
      this.latestEventTime = this.editor.endDate;
      this.firstEventOffset =
        this.editor.startOffset >= 0
          ? `(+${this.editor.startOffset})`
          : `(-${this.editor.startOffset})`;
      this.latestEventOffset =
        this.editor.endOffset >= 0
          ? `(+${this.editor.endOffset})`
          : `(-${this.editor.endOffset})`;
    }

    this.latestEventTimeShow = await this.dateService.setFullTimeString(this.latestEventTime.dateTime);
    this.firstEventTimeShow = await this.dateService.setFullTimeString(this.firstEventTime.dateTime);

    this.activitySpansMultipledays = !this.editor.endDate || !this.editor.endDate.dateTime || !(
      this.editor.startDate.dateTime.year === this.editor.endDate.dateTime.year &&
      this.editor.startDate.dateTime.month === this.editor.endDate.dateTime.month &&
      this.editor.startDate.dateTime.day === this.editor.endDate.dateTime.day
    );

    this.loading = false;
  }

  async timeChanged() {
    // use temp variable here so the Confirm button doesn't flash active then immediately disable
    const tempTimeValid = await this.dateService.timeAllowed(
      this.cancellationTimeToShow,
      this.editor.cancellationTime && this.editor.cancellationTime.dateTime
        ? this.editor.cancellationTime.dateTime
        : this.firstEventTime.dateTime
    );

    if (tempTimeValid) {
      const ptDate = await this.dateService.setPtLuxonDateFromUserEnteredString(
        this.cancellationTimeToShow,
        this.editor.cancellationTime && this.editor.cancellationTime.dateTime
          ? this.editor.cancellationTime.dateTime
          : this.firstEventTime.dateTime
      );

      this.timeIsValid = ptDate.dateTime >= this.firstEventTime.dateTime;

      if (this.timeIsValid) {
        this.editor.cancellationTime = ptDate;
        this.editor.endDate = ptDate;
      }
    } else {
      this.timeIsValid = false;
    }
  }

  async cancel() {
    this.callback(this.editor, true).then(() => {
      this.navCtrl.pop();
    });
  }

  async confirm() {
    this.loading = true;
    this.editor.cancellationNotes = this.notes;

    this.callback(this.editor, false).then(() => {
      this.navCtrl.pop();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-edit-cancel/jacking-activity-edit-cancel.ts